import React from "react";
import { Button } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { designColors, designShell } from "services/constants/designTokens";

export const RequestCancelButton = ({
  onClick,
  disabled = false,
  children = "Cancel Request",
  sx = {},
}) => (
  <Button
    variant="outlined"
    onClick={onClick}
    disabled={disabled}
    startIcon={<DeleteOutlineIcon sx={{ fontSize: 17 }} />}
    sx={{
      ...designShell.panelActionButton,
      width: "100%",
      minWidth: 0,
      minHeight: 42,
      color: "#E11D48",
      borderColor: "#FDA4AF",
      backgroundColor: designColors.white,
      "&:hover": {
        color: "#BE123C",
        borderColor: "#FB7185",
        backgroundColor: "#FFF1F3",
      },
      ...sx,
    }}
  >
    {children}
  </Button>
);

export default RequestCancelButton;
